import { Injectable, computed, signal } from '@angular/core';
import { ThemeConfiguration } from 'src/app/home/components/dynamic-home-page/dynamic-home-page.component';

@Injectable({
  providedIn: 'root'
})
export class ThemeConfigurationService {

  private _themeConfiguration = signal<ThemeConfiguration | null>(null);
  readonly themeConfiguration = this._themeConfiguration.asReadonly();

  // Computed signals for derived state
  readonly hasThemeConfiguration = computed(() => !!this._themeConfiguration());
  readonly themeConfigurationNonNull = computed(() => this._themeConfiguration());

  updateThemeConfiguration(config: ThemeConfiguration | null) {

    this._themeConfiguration.set(config);
  }
}
